import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { isUrl } from "../../../urlUtils";
import { styled } from "../../../theme";
import { Button } from "../../../button";
import { Text } from "../../../text";
import { FlexColumn } from "../../../box";
import { SUPPORTED_MEDIA_TYPE_IMAGES } from "../../snapshot-control-field/utils";
import { FileInput } from "../file-input";
import { ReactComponent as CameraPlaceholder } from "./assets/placeholder-camera.svg";
import { getPreSignedUrl } from "../../formHelpers";
const ClickDelegate = styled.label `
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  max-width: Max(30rem, 30em);
  width: 100%;
`;
const ClearButton = styled(Button) `
  margin-left: 25px;

  &:hover {
    transition-delay: 100ms;
  }

  ${({ disabled, theme }) => disabled &&
    `
    color: ${theme.color.darkBlue60};
    border-color: ${theme.color.darkBlue60};
  `}
  ${({ hidden }) => hidden &&
    `
    visibility: hidden;
  `}
  &[type="button"] {
    font-size: 0.6875em;
    padding-block: 0.45em;
    padding-inline: 0.625em 1em;
  }

  .icon.icon {
    position: initial;
    display: grid;
    font-size: 1em;
    margin-right: 0.5em;
  }

  span[style*="margin: 0px auto;"] {
    padding-top: 0.125em;
  }
`;
const FlexStart = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 0.625em;
`;
const ImagePreviewContainer = styled.div `
  display: flex;
  border-radius: 8px;
  color: ${({ theme }) => theme.color.primary};
  border: 1px solid ${({ theme }) => theme.color.primary};
  background-color: rgba(43, 183, 217, 0.05);
  ${({ disabled }) => disabled &&
    `
    opacity: 0.6;
    filter: saturate(25%);
`}
`;
const EmptyMessage = styled(FlexColumn) `
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1.25em 0.625em;
  user-select: none;

  @media (min-width: ${({ theme }) => theme.breakpoint.lg}px) {
    height: Max(18.75rem, 18.75em);
  }
`;
const PaddedImage = styled.img `
  padding: 10px;
  width: 100%;
`;
const CameraGlyph = styled.svg `
  width: 6.25em;
  margin-bottom: 15px;

  g {
    stroke: ${({ theme }) => theme.color.primary};
  }

  ~ span {
    font-size: 1.25em;
    text-align: center;
  }
`;
export const SnapshotControl = ({ name, image, disabled, textSize, onChange, transformUrl, onClear, }) => {
    const [preSignedUrl, setPreSignedUrl] = useState(null);
    // Fetch and update the AWS pre-signed URL if the input is a valid URL
    useEffect(() => {
        const fetchFileDetails = async (url) => {
            try {
                const preSignedUrl = await getPreSignedUrl(url, transformUrl);
                setPreSignedUrl(preSignedUrl);
            }
            catch {
                // Silently handle file fetch errors - component handles missing images gracefully
            }
        };
        if (image && isUrl(image)) {
            fetchFileDetails(image); // Fetch file details from the URL.
        }
    }, [image, transformUrl]);
    return (_jsxs(FlexStart, { style: { fontSize: `${textSize}rem` }, children: [_jsx(ClickDelegate, { disabled: disabled, children: _jsxs(ImagePreviewContainer, { disabled: disabled, "data-test-id": `${name}-preview`, children: [image ? (_jsx(PaddedImage, { src: preSignedUrl || image, alt: "Camera Preview" })) : (_jsxs(EmptyMessage, { children: [_jsx(CameraGlyph, { className: "image-placeholder-camera", children: _jsx(CameraPlaceholder, {}) }), _jsx(Text, { fontSize: 4, children: "Tap here to add photo" })] })), _jsx(FileInput, { value: "", name: name, multiple: false, acceptedMediaTypes: SUPPORTED_MEDIA_TYPE_IMAGES, disabled: disabled, onChange: onChange })] }) }), image && (_jsx(ClearButton, { outline: true, color: "danger", size: "small", icon: "close", onClick: onClear, disabled: disabled, children: "Remove" }))] }));
};
SnapshotControl.defaultProps = {
    textSize: 1,
    onChange: () => { },
    onClear: () => { },
    transformUrl: (url) => url,
};
